// Two sleeps of one baby cannot cover the same time (the server refuses it with sleep_overlap, see
// apps/server/src/modules/tracker/service.ts). Checked on the phone too, so the form can say so at once.

/** Same slack as the server: minute-precision forms next to timers stopped to the second. */
export const SLEEP_OVERLAP_SLACK_MS = 60_000;
const MAX_SLEEP_MS = 24 * 3600_000;

type Span = { startAt: string; endAt: string | null };

/** [start, end] in ms; a running sleep covers start → now (at most a day). */
function span(e: Span, now: number): [number, number] {
  const a = Date.parse(e.startAt);
  return [a, e.endAt ? Date.parse(e.endAt) : Math.min(Math.max(now, a), a + MAX_SLEEP_MS)];
}

/** The first of `others` that overlaps `sleep` by more than the slack, or null. */
export function findOverlap<T extends Span>(sleep: Span, others: T[], now = Date.now()): T | null {
  const [a, b] = span(sleep, now);
  for (const o of others) {
    const [c, d] = span(o, now);
    if (c < b - SLEEP_OVERLAP_SLACK_MS && a < d - SLEEP_OVERLAP_SLACK_MS) return o;
  }
  return null;
}
